import React from 'react';
import { Progress } from '../ui/progress';
import { t } from '../../lib/i18n';
import { STEPS, STEP_ICONS } from './constants';

export const OnboardingStepper = ({ step, language }) => {
  const progressPercent = ((step + 1) / STEPS.length) * 100;
  return (
    <div className="mb-6">
      <Progress value={progressPercent} className="h-1 bg-white/5" data-testid="onboarding-stepper" />
      <div className="flex justify-between mt-3">
        {STEPS.map((s, i) => {
          const Icon = STEP_ICONS[i];
          return (
            <div
              key={s}
              data-testid={`onboarding-step-indicator-${i}`}
              className={`flex flex-col items-center gap-1 transition-colors duration-200 ${i <= step ? 'text-[var(--lux-gold)]' : 'text-white/20'}`}
            >
              <Icon className="w-4 h-4" />
              <span className="text-[10px] uppercase tracking-wider hidden sm:block">{t(s, language)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
